import { selectedWidgetDataReducer } from 'src/react/selectedWidget/reducers/SelectedWidgetDataReducer';

export const selectedWidgetReducer = selectedWidgetDataReducer;
